module.exports = __webpack_public_path__ + "img/502.e2763b8d.png";